import { render } from "./DateHistoryView.vue?vue&type=template&id=724e1be8&scoped=true"
import script from "./DateHistoryView.vue?vue&type=script&lang=js"
export * from "./DateHistoryView.vue?vue&type=script&lang=js"

import "./DateHistoryView.vue?vue&type=style&index=0&id=724e1be8&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724e1be8"]])

export default __exports__